define('app/controllers.js',[], function() {

    var controllers = {};

    controllers.appCtrl = function($scope, $location, $timeout, $interval, $translate, dataService) {

        $scope.language = $location.search().lang || "en";
        $translate.use($scope.language);

        $scope.countryField = "Country-" + $scope.language;
        $scope.causeField = "Cause of Death-" + $scope.language;


        $translate("YOUR_BUTTON").then(function(yourButton) {
            $scope.yourButton = yourButton;
        });
        $translate("EUROPE_BUTTON").then(function(europeButton) {
            $scope.europeButton = europeButton;
        });

        //updates availability of next button
        var nextInterval = $interval(function() {
            var value, next;
            if($scope.activeSlide === 0) {
                value = $scope.selectedGender;
            } else if ($scope.activeSlide === 1) {
                value = $scope.selectedCountry;
            } else if ($scope.activeSlide === 2) {
                value = $scope.selectedAge;
            }

            if(value === undefined || value === null || value === "" || value === "GEO_SELECT") {
                next = false;
            } else {
                next = true;
            }

            if(next) {
                $(".right.carousel-control").removeClass("disabled");
            } else {
                $(".right.carousel-control").addClass("disabled");
            }
        }, 200);

        $scope.$on('$destroy', function() {
          // Make sure that the interval is destroyed too
          $interval.cancel(nextInterval);
        });

        //qlik charts
        //dataService.app.getObject("causes-chart-results", "LqCSJT");
        //dataService.app.getObject("causes-chart-all", "LqCSJT");

        dataService.app.visualization.create("barchart",
            [{qDef: {qDef: "Avg({<Category={'Cause of Death'},Age=>} Data)", qLabel: "Death Rate (by 100,000 inhabitants)"}}, $scope.causeField],
            {orientation: "horizontal", dataPoint: {showLabels: true}}
        ).then(function(viz) {
            viz.show("causes-chart-results");
            viz.show("causes-chart-all");
        })

        //other qlik data
        dataService.app.createGenericObject({
            cause: {
                qStringExpression: "FirstSortedValue({<Age=>}[" + $scope.causeField + "], -Aggr(Avg({<Category={'Cause of Death'},Age=>} Data), [Cause of Death]))"
            },
            life: {
                qStringExpression: "Avg([Life Expectancy Age])"
            },
            euroLife: {
                qStringExpression: "Avg({<[" + $scope.countryField + "]=>}[Life Expectancy Age])"
            }
        }, function(reply) {
            // console.log(reply);
            $scope.cause = reply.cause;
            $scope.life = Number(reply.life).toFixed(1);
            $scope.euroLife = Number(reply.euroLife).toFixed(1);
        });

        //country list
        dataService.app.createList({
            qDef: {
                qFieldDefs: [$scope.countryField],
                qSortCriterias: [{
                    qSortByState: 1
                }]
            },
            qInitialDataFetch: [{
                qWidth: 1,
                qHeight: 100
            }]
        }, function(reply) {
            $scope.countries = reply.qListObject.qDataPages[0].qMatrix.map(function(row) {
                return {
                    name: row[0].qText,
                    qElemNumber: row[0].qElemNumber,
                    qState: row[0].qState
                }
            })
        });

        $scope.clearAll = function() {
            dataService.app.clearAll();
            $scope.gender= {Male: false, Female: false};
        }

        

        //apply choices
        $scope.applyChoices = function(animate) {
            if(!$scope.selectedGender || !$scope.selectCountry || !$scope.selectedAge) { return }
            // console.log("apply");
            $scope.showResults = false;
            $scope.life = 0;
                dataService.app.field("Gender").selectMatch($scope.selectedGender).then(function() {
                    return dataService.app.field($scope.countryField).selectMatch($scope.selectedCountry);
                }).then(function() {
                    return dataService.app.field("Age").selectMatch($scope.selectedAge);
                }).then(function() {
                    $scope.showResults = true;
                    if(animate) {
                        $timeout(function() {
                            var decimal_places = 1;
                            var decimal_factor = decimal_places === 0 ? 1 : Math.pow(10, decimal_places);
                            $("#results-life span").animateNumber({
                                number: $scope.life * decimal_factor,
                                numberStep: function(now, tween) {
                                    var floored_number = Math.floor(now) / decimal_factor,
                                        target = $(tween.elem);

                                    if (decimal_places > 0) {
                                    // force decimal places even if they are 0
                                    floored_number = floored_number.toFixed(decimal_places);

                                    // replace '.' separator with ','
                                    //floored_number = floored_number.toString().replace('.', ',');
                                    }

                                    target.text(floored_number);
                                }, 
                                easing: 'easeInOutQuad'
                            }, 10000);
                            qlik.resize();
                        },1000);
                    }
                    $scope.showResults = true;
                });
        }

        //clear choices
        $scope.clearChoices = function() {
            $scope.showResults = false;
            dataService.app.clearAll().then(function() {
                $scope.showResults = true;
                qlik.resize();
            });
        }

        //watches for active to be results page, makes appropriate selections
		$scope.activeSlide = 0;
        $scope.$watch("activeSlide", function(activeSlide) {
            if(activeSlide === 3) {
                $scope.activeTab = 0;
                $scope.applyChoices(true);
            } else {
                $scope.showResults = false;
            }
        });

        $scope.next = function() {
            $scope.activeSlide = $scope.activeSlide + 1;
        }

        $scope.prev = function() {
            $scope.activeSlide = $scope.activeSlide - 1;
        }

        //mock data
        // $scope.countries = [
        //     {
        //         name: "France"
        //     },
        //     {
        //         name: "Germany"
        //     },
        //     {
        //         name: "Sweden"
        //     }
        // ];
        $scope.selectedCountry = 'GEO_SELECT';
		
        //change functions
		$scope.changeGender = function(gender) {
			$scope.selectedGender = gender;
            $translate(gender.toUpperCase()).then(function(gender) {
                $scope.transGender = gender;
            });
		}
        $scope.changeCountry = function(country) {
            $scope.selectedCountry = country;
        }
        $scope.changeAge = function(age) {
            if (age == "") {
                $scope.selectedAge = null;
            } else if (age == 0) {
                $scope.selectedAge = "Less than 1 year";
                $scope.formattedSelectedAge = "< 1"
            } else if (age == 1) {
                $scope.selectedAge = "1 year"
                $scope.formattedSelectedAge = "1";
            } else if (age >= 85) {
                $scope.selectedAge = "85 years or older"
                $scope.formattedSelectedAge = "85+"
            } else {
                $scope.selectedAge = age + " years";
                $scope.formattedSelectedAge = $scope.selectedAge.match(/\d+/)[0];
            }
            
        }

        //validate age input
        $scope.validate = function(event) {
            var keyCode = event.which || event.keyCode;
            if(!event.key.match(/^\d+$/) && keyCode != 8) {
                event.preventDefault();
            }
        }

        //select country
        $scope.selectCountry = function(country) {
            dataService.app.field("Country").selectMatch(country.name);
            $($("ul")[1]).scrollTop(0);
        }

        $scope.gender= {Male: false, Female: false};
        $scope.setGender = function() {
            var genders = Object.keys($scope.gender);
            var activeGenders = genders.filter(function(gender) { return $scope.gender[gender] });
            dataService.app.field("Gender").selectValues(activeGenders, false, false);
        }

        $scope.startAgain = function() {
            $scope.clearAll();
            $scope.activeSlide = 0;
        }

        $scope.translationData = {
            cause: "Test"
        }
		
	};
    controllers.appCtrl.$inject = ['$scope', '$location', '$timeout', '$interval', '$translate', 'dataService'];

    controllers.resultCtrl = function($scope, $location, $timeout, dataService) {
		
	};
    controllers.resultCtrl.$inject = ['$scope', '$location', '$timeout', 'dataService'];

    return controllers;
});
